/* Public, finite page labels only. Shopify remains the consent authority. */
(() => {
  const script = document.currentScript;
  const endpoint = script?.dataset.endpoint;
  const page = script?.dataset.page;
  if (!endpoint || !['home','product','collection','blog','article','search','page'].includes(page)) return;
  // Defence in depth if an app renders the storefront layout on a private route.
  if (/\/(account|accounts|cart|checkout|checkouts|orders|password)(\/|$)/i.test(location.pathname)) return;
  let store; try { store = localStorage; } catch { return; }
  const key = 'goldie_usage_receipts';
  const privacy = () => window.Shopify?.customerPrivacy;
  const allowed = () => {
    try { return !navigator.webdriver && !navigator.globalPrivacyControl && navigator.doNotTrack !== '1'
      && !store.getItem('goldie_usage_off')
      && privacy()?.currentVisitorConsent().analytics === 'yes'
      && privacy()?.analyticsProcessingAllowed() === true; } catch { return false; }
  };
  const receipts = () => {
    try { return JSON.parse(store.getItem(key) || '[]').filter(r => typeof r.receipt === 'string' && r.expires > Date.now()).slice(-30); }
    catch { return []; }
  };
  let sent = false;
  const send = async () => {
    if (!allowed() || sent) return;
    sent = true;
    try {
      const response = await fetch(endpoint + '/e', {method:'POST',credentials:'omit',referrerPolicy:'no-referrer',headers:{'Content-Type':'text/plain'},body:JSON.stringify({e:[{k:'view',p:'/'+page}]})});
      if (!response.ok) return;
      const body = await response.json();
      // Keep rights authorization even if consent was withdrawn in flight.
      // This receipt is never sent with collection or used as a visitor ID.
      if (typeof body.receipt !== 'string' || body.receipt.length > 384) return;
      store.setItem(key, JSON.stringify([...receipts().filter(r=>r.receipt!==body.receipt),{receipt:body.receipt,expires:Date.now()+29*86400000}].slice(-30)));
    } catch { /* No background retries or impact on shopping. */ }
  };
  document.addEventListener('visitorConsentCollected', send);
  if (privacy()) send();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) send(); });
  const panel = document.getElementById('goldie-usage-rights');
  if (!panel) return;
  const status = panel.querySelector('[data-usage-status]');
  panel.addEventListener('click', async event => {
    const action = event.target.closest('[data-usage-action]')?.dataset.usageAction;
    if (!action) return;
    if (action === 'withdraw') {
      store.setItem('goldie_usage_off','yes');
      status.textContent = 'Optional usage tracking is off on this browser.';
      privacy()?.setTrackingConsent({analytics:false}, error => { if (error) status.textContent += ' Shopify consent could not be updated. Please also use the store cookie preferences.'; });
      return;
    }
    if (!['export','erase'].includes(action) || panel.dataset.busy) return;
    if (action === 'erase' && !window.confirm('Erase the usage records represented by this browser’s receipts? Anonymous aggregate counts remain.')) return;
    panel.dataset.busy = 'yes'; status.textContent = 'Working…';
    const known = receipts(), results = [], remaining = [];
    try {
      for (const record of known) {
        try {
          const response = await fetch(endpoint+'/rights',{method:'POST',credentials:'omit',referrerPolicy:'no-referrer',headers:{'Content-Type':'text/plain'},body:JSON.stringify({action,receipt:record.receipt})});
          const body = await response.json();
          if (!response.ok || !body.ok) throw Error('rights');
          results.push(body);
        } catch { remaining.push(record); }
      }
      if (action === 'erase') store.setItem(key,JSON.stringify(remaining));
      if (action === 'export' && results.length) {
        const url=URL.createObjectURL(new Blob([JSON.stringify(results,null,2)],{type:'application/json'}));
        const link=document.createElement('a');link.href=url;link.download='goldie-usage.json';link.click();URL.revokeObjectURL(url);
      }
      status.textContent = remaining.length ? 'Some requests failed. Receipts were kept so you can retry.' : known.length ? (action === 'erase' ? 'Usage records erased. Anonymous aggregate counts remain.' : 'Usage export downloaded.') : 'No unexpired usage receipts on this browser.';
    } finally { delete panel.dataset.busy; }
  });
})();
